export default "/assets/webpack-assets/GT-Walsheim-Pro-Light-Oblique.7fd9c584681c485d02b3d6c4574dfdb1.woff";